export default __webpack_public_path__ + "static/media/shuenwan-main.5f38feb9.jpg";